import React from 'react';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import Layout from '../../common/Layout';
import SEO from '../../common/SEO';
import { CoursesProvider } from '../../context/courses_context';
import { FilterProvider } from '../../context/filter_context';
import PosttDataaToefl from './PosttDataaToefl.json'
import PostOneeToefl from './PostOneeToefl';



const ToeflInnerr = () => {
    return (
        <>
            <SEO title="TOEFL Inner" />
            <Layout>
                <BreadcrumbOne
                    // title="Study Abroad eBooks"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Test of English as a Foreign Language(TOEFL)"
                />
                <CoursesProvider>
                    <FilterProvider>
                        <div className="edu-course-area  bg-color-white"style={{marginBottom:"100px"}}>
                            <div className="container">
                                <div className="row g-5">
                                    
                                    
                                    <div className="edu-elements-area bg-color-white">
                                        <div className="container">
                                            <div className="row g-5">
                                                <div className="col-lg-12">
                                                    <div className="row g-5">
                                                        {
                                                            PosttDataaToefl.slice(0, 12).map((item) => (
                                                                <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                                    <PostOneeToefl data={item} />
                                                                </div>
                                                            ))
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <FaqIELTS /> */}

                                 

                                </div>
                            </div>
                        </div>
                    </FilterProvider>
                </CoursesProvider>

                <div >

                </div>
            </Layout>
        </>
    )
}

export default ToeflInnerr;